import { AppEvent } from './../../../app_bus/app-event';
export class ToneRemovedEvent extends AppEvent {
    constructor(toneEntry) {
        super("Clicked remove tone entry");
        this.toneEntry = toneEntry;
    }
}
//# sourceMappingURL=tone-removed-event.js.map